import styled from 'styled-components';

const FormFieldError = styled.p`
  font-size: ${(props) => props.theme.fonts.body3.fontSize};
  line-height: ${(props) => props.theme.fonts.body3.lineHeight};
  color: ${(props) => props.theme.colors.danger};
`;

export { FormFieldError };
